import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "services/api";

import { AccountContext } from "context/account";
import toast from "react-hot-toast";
import qs from "query-string";

import ProjectDetail from "pages/de/project/detail";
import Error404 from "pages/error/404";

const ProjectList = () => {
  const [detail, setDetail] = useState([]);
  const user = useContext(AccountContext);

  const [pageLoading, setPageLoading] = useState(true);

  let location = useLocation();
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);
  const projectId = urlObj?.query?.id;

  useEffect(() => {
    if (projectId) {
      retrieveProjectDetail(projectId);
    }
  }, [projectId]);

  const retrieveProjectDetail = async (id) => {
    try {
      setPageLoading(true);
      const { data } = await api.project.get(id);
      const project = data["project"] ? data["project"] : {};
      setDetail(project);
      setPageLoading(false);
    } catch (err) {
      console.log(err);
      setPageLoading(false);
    }
  };

  return projectId ? <ProjectDetail project={detail} pageLoading={pageLoading} /> : <Error404 />;
};

export default ProjectList;
